import type { FilterState, Tag, Dealership } from '../types';

interface Props {
  filters: FilterState;
  onChange: (f: Partial<FilterState>) => void;
  onClear: () => void;
  tags: Tag[];
  dealerships: Dealership[];
}

export default function ActiveFilters({ filters, onChange, onClear, tags, dealerships }: Props) {
  const pills: { label: string; onRemove: () => void }[] = [];

  if (filters.search) pills.push({ label: `Search: "${filters.search}"`, onRemove: () => onChange({ search: '' }) });

  filters.vehicle_class.forEach(c => pills.push({ label: `Class: ${c}`, onRemove: () => onChange({ vehicle_class: filters.vehicle_class.filter(v => v !== c) }) }));
  filters.category.forEach(c => pills.push({ label: `Cat: ${c}`, onRemove: () => onChange({ category: filters.category.filter(v => v !== c) }) }));
  filters.tier.forEach(t => pills.push({ label: t, onRemove: () => onChange({ tier: filters.tier.filter(v => v !== t) }) }));
  filters.progress.forEach(p => pills.push({ label: p, onRemove: () => onChange({ progress: filters.progress.filter(v => v !== p) }) }));

  if (filters.dealership_id) {
    const d = dealerships.find(d => String(d.id) === filters.dealership_id);
    pills.push({ label: `Dealership: ${d?.name ?? filters.dealership_id}`, onRemove: () => onChange({ dealership_id: '' }) });
  }
  if (filters.dealership_available) pills.push({ label: 'Has Dealership', onRemove: () => onChange({ dealership_available: false }) });
  if (filters.boosting_exclusive) pills.push({ label: 'Boost Excl.', onRemove: () => onChange({ boosting_exclusive: false }) });
  if (filters.rp_exclusive) pills.push({ label: 'RP Excl.', onRemove: () => onChange({ rp_exclusive: false }) });

  filters.tag_ids.forEach(tid => {
    const tag = tags.find(t => String(t.id) === tid);
    pills.push({ label: `Tag: ${tag?.name ?? tid}`, onRemove: () => onChange({ tag_ids: filters.tag_ids.filter(v => v !== tid) }) });
  });

  if (pills.length === 0) return null;

  return (
    <div
      className="flex items-center gap-2 flex-wrap px-4 py-2 border-b"
      style={{ borderColor: 'var(--border)', background: 'var(--surface)' }}
    >
      <span className="font-heading uppercase text-xs" style={{ color: 'var(--text-muted)' }}>Filters:</span>
      {pills.map((p, i) => (
        <span key={i} className="inline-flex items-center gap-1 bg-dark text-white pill text-xs font-body px-2 py-0.5">
          {p.label}
          <button onClick={p.onRemove} className="text-white/60 hover:text-white ml-0.5 leading-none">×</button>
        </span>
      ))}
      <button onClick={onClear} className="text-xs font-body underline ml-auto" style={{ color: 'var(--text-muted)' }}>
        Clear all
      </button>
    </div>
  );
}
